import { emit } from "./eventEmitter.js";

export const initiateWidgetCall = async (widgetId) => {
  if (!widgetId) {
    console.error("Call cannot be initiated; widget ID not specified");
    emit("error", new Error("Widget ID not specified"));
    return;
  }

  try {
    const response = await fetch(`https://indigenius.shop/widget/create-call`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ widget_id: widgetId }),
    });

    const responseBody = await response.text();
    console.log("API Response:", responseBody);

    if (!response.ok) {
      throw new Error(
        `Failed to initiate widget call: ${response.statusText} - ${responseBody}`
      );
    }

    const data = JSON.parse(responseBody);
    emit("widgetTheme", data);

    return data;
  } catch (error) {
    console.error("Error initiating widget call", error);
    emit("error", error);
    throw error;
  }
};
